import styled from 'styled-components/macro';

export const HideMobile = styled.div`
    @media (max-width: ${(props) => props.theme.width.med}) {
        display: none;
    }
`;
